module.exports = __webpack_public_path__ + "img/Revoked.a09881bf.png";